import Body from "./Body";
import Search from "./Search";
import Filter from "./Filter";
import Update from "./Update";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";

export const Components = {
  Body,
  Search,
  Filter,
  Update,
  Create,
  Delete,
  Detail,
};
